// Generated by genversion.
export const version = '5.12.0';
